/* Dog Dock — bundle cards and sticky add-to-cart (no dependencies) */
(function () {
  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  if (!customElements.get('ds-bundle-cards')) {
    customElements.define(
      'ds-bundle-cards',
      class DsBundleCards extends HTMLElement {
        connectedCallback() {
          this.optionName = this.dataset.optionName;
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.options = JSON.parse(this.querySelector('[data-options]').textContent);
          this.optionIndex = this.options.indexOf(this.optionName);
          this.cards = Array.from(this.querySelectorAll('.ds-bundle'));

          this.cards.forEach((card) => {
            card.addEventListener('click', () => this.select(card.dataset.value));
          });

          this.onChange = () => window.requestAnimationFrame(() => this.refresh());
          document.addEventListener('change', this.onChange);
          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
            this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, this.onChange);
          }
          this.refresh();
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.onChange);
          if (this.unsub) this.unsub();
        }

        picker() {
          const info = document.getElementById('ProductInfo-' + this.dataset.section);
          return (info || document).querySelector('variant-selects');
        }

        selectedValues() {
          const values = {};
          const picker = this.picker();
          if (!picker) return values;
          picker.querySelectorAll('input:checked, select').forEach((el) => {
            if (el.tagName === 'SELECT') {
              const opt = el.options[el.selectedIndex];
              const name = el.closest('.product-form__input') && el.closest('.product-form__input').querySelector('label');
              if (opt && el.dataset.optionName) values[el.dataset.optionName] = opt.value;
              else if (opt && name) values[name.textContent.trim()] = opt.value;
            } else if (el.dataset.optionName) {
              values[el.dataset.optionName] = el.value;
            }
          });
          return values;
        }

        findVariant(packValue, selected) {
          return this.variants.find((v) =>
            this.options.every((name, i) => {
              if (i === this.optionIndex) return v.options[i] === packValue;
              return selected[name] === undefined || v.options[i] === selected[name];
            })
          );
        }

        refresh() {
          const selected = this.selectedValues();
          const current = selected[this.optionName];
          const single = this.cards.find((c) => c.dataset.units === '1');
          const singleVariant = single ? this.findVariant(single.dataset.value, selected) : null;

          const promo = parseInt(this.dataset.promo, 10) || 0;
          const off = (cents) => Math.round((cents * (100 - promo)) / 100);

          this.cards.forEach((card) => {
            const variant = this.findVariant(card.dataset.value, selected);
            const amount = card.querySelector('[data-amount]');
            const save = card.querySelector('[data-save]');
            const was = card.querySelector('[data-was]');
            if (was) was.textContent = '';
            card.setAttribute('aria-pressed', String(card.dataset.value === current));
            if (!variant) {
              amount.textContent = '';
              save.textContent = '';
              card.dataset.unavailable = 'true';
              return;
            }
            card.dataset.unavailable = String(!variant.available);
            const units = parseInt(card.dataset.units, 10);
            save.textContent = '';
            if (promo > 0) {
              const paid = off(variant.price);
              amount.textContent = money(paid, this.dataset.currency, this.dataset.locale);
              if (was) was.textContent = money(variant.price, this.dataset.currency, this.dataset.locale);
              const reference = singleVariant && units > 1 ? singleVariant.price * units : variant.price;
              save.textContent = 'You save ' + money(reference - paid, this.dataset.currency, this.dataset.locale);
              return;
            }
            amount.textContent = money(variant.price, this.dataset.currency, this.dataset.locale);
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              save.textContent = 'Save ' + money(variant.compare_at_price - variant.price, this.dataset.currency, this.dataset.locale);
            } else if (singleVariant && units > 1) {
              const diff = singleVariant.price * units - variant.price;
              if (diff > 0) save.textContent = 'Save ' + money(diff, this.dataset.currency, this.dataset.locale);
            }
          });
        }

        select(value) {
          const picker = this.picker();
          if (!picker) return;
          const input = Array.from(picker.querySelectorAll('input[type="radio"]')).find(
            (el) => el.dataset.optionName === this.optionName && el.value === value
          );
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          const select = Array.from(picker.querySelectorAll('select')).find((el) =>
            Array.from(el.options).some((o) => o.value === value && el.closest('fieldset, .product-form__input'))
          );
          if (select) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    );
  }

  /* Sticky add to cart: shows once the main buy button scrolls out of view */
  function initSticky() {
    const bar = document.querySelector('[data-ds-sticky]');
    if (!bar) return;
    const mainButton = document.querySelector('product-form button[type="submit"][name="add"]');
    if (!mainButton) return;
    const cta = bar.querySelector('[data-ds-sticky-cta]');
    const price = bar.querySelector('[data-ds-sticky-price]');

    const syncPrice = () => {
      const current = document.querySelector('[id^="price-template"] .price-item--sale, [id^="price-template"] .price-item--regular');
      if (current && price) price.textContent = current.textContent.trim();
    };
    syncPrice();
    document.addEventListener('change', () => setTimeout(syncPrice, 400));

    cta.addEventListener('click', () => {
      const btn = document.querySelector('product-form button[type="submit"][name="add"]');
      if (btn && !btn.disabled) {
        btn.click();
      } else {
        document.querySelector('product-info, .product').scrollIntoView({ behavior: 'smooth' });
      }
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const below = entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', !entry.isIntersecting && below);
        });
      },
      { threshold: 0 }
    );
    io.observe(mainButton);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();

/* Dog Dock rolling countdown: 13–14h per visit, stored in localStorage. Resets when it hits zero. */
(function () {
  var STORAGE_KEY = 'dd_countdown_end_v1';
  function pad(n) { return String(n).padStart(2, '0'); }
  function readEnd() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var v = parseInt(raw, 10);
      return isNaN(v) ? null : v;
    } catch (e) { return null; }
  }
  function writeEnd(ts) {
    try { localStorage.setItem(STORAGE_KEY, String(ts)); } catch (e) {}
  }
  function newEnd(minHrs, maxHrs) {
    var range = Math.max(1, maxHrs - minHrs);
    var extraMs = Math.floor(Math.random() * range * 3600 * 1000);
    return Date.now() + minHrs * 3600 * 1000 + extraMs;
  }
  function getEnd(minHrs, maxHrs) {
    var end = readEnd();
    if (!end || end <= Date.now()) {
      end = newEnd(minHrs, maxHrs);
      writeEnd(end);
    }
    return end;
  }
  function init() {
    document.querySelectorAll('[data-ds-rolling], [data-ds-countdown]').forEach(function (bar) {
      var minHrs = parseInt(bar.getAttribute('data-min-hours'), 10) || 13;
      var maxHrs = parseInt(bar.getAttribute('data-max-hours'), 10) || 14;
      var legacy = bar.getAttribute('data-ds-countdown');
      var legacyEnd = legacy ? Date.parse(legacy) : NaN;
      var useLegacy = legacy && !isNaN(legacyEnd) && legacyEnd > Date.now();
      var end = useLegacy ? legacyEnd : getEnd(minHrs, maxHrs);
      var el = {
        d: bar.querySelector('[data-d]'),
        h: bar.querySelector('[data-h]'),
        m: bar.querySelector('[data-m]'),
        s: bar.querySelector('[data-s]')
      };
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (left === 0 && !useLegacy) {
          try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
          end = getEnd(minHrs, maxHrs);
          left = end - Date.now();
        } else if (left === 0 && useLegacy) {
          bar.hidden = true;
          return;
        }
        var s = Math.floor(left / 1000);
        if (el.d) el.d.textContent = pad(Math.floor(s / 86400));
        if (el.h) el.h.textContent = pad(Math.floor((s % 86400) / 3600));
        if (el.m) el.m.textContent = pad(Math.floor((s % 3600) / 60));
        if (el.s) el.s.textContent = pad(s % 60);
      }
      setInterval(tick, 1000);
      tick();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Dog Dock high-demand stock counter: pseudo-live decrement 47 → 12, cookie-based per visit */
(function () {
  var STORAGE_KEY = 'dd_stock_v1';
  var MIN = 12, START = 47;
  function readStock() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var v = parseInt(raw, 10);
      return isNaN(v) ? null : v;
    } catch (e) { return null; }
  }
  function writeStock(v) {
    try { localStorage.setItem(STORAGE_KEY, String(v)); } catch (e) {}
  }
  function getStock() {
    var v = readStock();
    if (v === null || v < MIN) {
      v = START - Math.floor(Math.random() * 8);
      writeStock(v);
    }
    return v;
  }
  function init() {
    var els = document.querySelectorAll('[data-ds-stock]');
    if (!els.length) return;
    var current = getStock();
    els.forEach(function (el) { el.textContent = current; });
    function drop() {
      if (current <= MIN) return;
      current -= 1;
      writeStock(current);
      els.forEach(function (el) { el.textContent = current; });
      setTimeout(drop, 40000 + Math.random() * 50000);
    }
    setTimeout(drop, 15000 + Math.random() * 20000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Carousel with arrow buttons (native scroll-snap underneath) */
if (!customElements.get('ds-carousel')) {
  customElements.define('ds-carousel', class extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-track]');
      if (!track) return;
      var step = function () {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      };
      this.querySelector('[data-prev]').addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      this.querySelector('[data-next]').addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    }
  });
}
